export default "__VITE_ASSET__DWV3bGVh__"